<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="订单管理系统" :bannerList="bannerList"></swiper>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <div class="row">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/orderManage/badge.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/orderManage/badge.png">
              <img src="@/assets/img/lg/orderManage/badge.png"  class="image-width-100"/>
            </picture>
          </div>
        </div>
      </div>
    </section>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <div class="row">
          <div class="col">
            <p class="title-sub text-line-height-1 indentation">
              随着客户(武汉)全国各地发来的销售订单日益增长，使得销售订单到发货的管理日益复杂，管理成本逐步上升，甚至会出现包装计划延迟执行，发货延迟。
              为了配合公司的发展战略，更好的满足客户要求，提升客户服务水准，特规划一套订单辅助发货平台。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 软件环境 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="软件环境"></main-title>
        <p class="title-sub text-line-height-1 indentation font-weight-500 color-desc">
          本系统采用B/S三层架构体系，将整个业务划分为表现层、业务逻辑层和数据访问层，实现高内聚低耦合的设计目标，保证系统的灵活性、高可扩展性等特点。
        </p>
        <desc-list :dataList="softwareList"></desc-list>
      </div>
    </section>

    <!-- 总体框架 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="总体框架"></main-title>
        <div class="row">
          <div class="col">
            <p class="title-sub text-line-height-1 indentation pb-4 color-desc">
              M方辅助发货平台主要由IO订单模块、待包装模块、包装计划模块、发货计划模块、物流模块、
              权限控制模块、日志跟踪模块、邮件系统、SAP访问模块、AD域模块，供应商模块十大部分组成。
            </p>
            <h1 class="title-main text-align-center font-weight-600 pb-3">订单管理平台</h1>
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/orderManage/eSupply.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/orderManage/eSupply.png">
              <img src="@/assets/img/lg/orderManage/eSupply.png" class="image-width-100"/>
            </picture>
            <div class="lg-hidden pt-3 text-line-height-2">
              <div v-for="item in frameList" :key="item.title">
                <span class="green-point font-weight-600 title-sub color-dark-grey">{{ item.title }}</span>
                <span class="title-sub">{{ item.titleDetail }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 参考词汇 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="参考词汇"></main-title>
        <div class="row">
          <div class="col">
            <p v-for="item in vocabularyList" :key="item" class="indentation text-line-height-1 title-sub color-desc">{{ item }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 项目功能 -->
    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <main-title title="项目功能"></main-title>
        <div class="row">
          <div class="col">
            <picture>
              <source media="(max-width: 768px)" srcset="@/assets/img/md/orderManage/success-case.png">
              <source media="(min-width: 768px)" srcset="@/assets/img/lg/orderManage/success-case.png">
              <img src="@/assets/img/lg/orderManage/success-case.png" class="image-width-100"/>
            </picture>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
export default {
  name: 'OrderManage',
  components: { Swiper,},
  props: {},
  data() {
    return {
      bannerList: [
        { src: require("@/assets/img/common/caseList/orderManage/banner1.png") },
        { src: require("@/assets/img/common/caseList/orderManage/banner2.png") },
        { src: require("@/assets/img/common/caseList/orderManage/banner3.png") },
      ],
      // 软件环境
      softwareList: [
        {
          title: "表示层：",
          titleDetail:
            "位于最外层（最上层），最接近用户。用于显示数据和接收用户输入的数据，为用户提供一种交互式操作的界面。",
        },
        {
          title: "业务逻辑层：",
          titleDetail:
            "位于数据访问层与表示层中间，是系统架构中最核心的部分，包含业务规则的制定、业务流程的实现、业务逻辑的处理等。",
        },
        {
          title: "数据访问层：",
          titleDetail:
            "也称为是持久层，位于最底层，其功能主要是负责数据库的访问与操作。",
        },
        {
          title: "技术架构选型：",
          titleDetail:
            "本系统采用当今比较流行三大框架：.net core、EF core、Nginx。",
        },
        {
          title: ".net core：",
          titleDetail:
            "net core是为.net 平台提供的一种跨平台的框架，可以完美的在Windows/Linux平台上部署.net服务器端程序。基于甲方的管理要求，我们提供基于Windows Server 2012及以上版本的服务程序版本。",
        },
      ],
      // 总体框架
      frameList: [
        {
          title: "用户界面层：",
          titleDetail:"门户页、订单管理、TODO列表、包装计划、物流信息发货计化、权限管理、日志查看、PO确认。"
        },
        {
          title: "业务逻辑层：",
          titleDetail:"IO订单、MP订单、TODO模块、系统日志、DO模块、发货管理、包装管理、物流模块、权限管理、定时任务配置。"
        },
        {
          title: "基础层：",
          titleDetail:"权限、日志、AD域接入、定时任务、邮件、通用数据、SAP函数、SAP采集。"
        },
        {
          title: "数据访问层：",
          titleDetail:"EF Core、SAP RFC、LDAP、物流信息接入。"
        },
        {
          title: "数据基础层：",
          titleDetail:"MS SQL SERVER、Redis、SAP、AD域。"
        }
      ],
      // 参考词汇
      vocabularyList: [
        'SO-> Sales Order NO 销售订单号（来自SAP）',
        'IO-> Internal Order 内部订单 (来自定制化业务)',
        'DO-> Delivery Order 交货单 （来自SAP）'
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {

  },
  created() {

  },
  mounted() {

  },
}
</script>
<style scoped>
</style>